
import { Button } from '@/components/ui/button';
import { Loader2, Save } from 'lucide-react';
import { DeleteProviderDialog } from './DeleteProviderDialog';
import type { PEOProvider } from '@/types/peo.types';

interface FormActionsProps {
  provider?: PEOProvider;
  onDelete: () => Promise<void>;
  isSubmitting: boolean;
  isDeleteInProgress: boolean;
}

export const FormActions = ({ 
  provider, 
  onDelete, 
  isSubmitting, 
  isDeleteInProgress 
}: FormActionsProps) => {
  return (
    <div className="flex justify-between space-x-4 sticky bottom-0 bg-background pt-4 pb-2 border-t">
      {provider && (
        <DeleteProviderDialog 
          onDelete={onDelete}
          providerName={provider.name}
          disabled={isDeleteInProgress || isSubmitting}
        />
      )}
      <div className="flex-1 flex justify-end">
        <Button
          type="submit"
          disabled={isSubmitting || isDeleteInProgress}
          size="lg"
          className="min-w-[180px] font-semibold"
        >
          {isSubmitting ? (
            <>
              <Loader2 className="mr-2 h-5 w-5 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save className="mr-2 h-5 w-5" />
              {provider ? 'Update Provider' : 'Add Provider'}
            </>
          )}
        </Button>
      </div>
    </div>
  );
};
